import { render, staticRenderFns } from "./DirectDealerManage.vue?vue&type=template&id=f7276ae4&scoped=true"
import script from "./DirectDealerManage.vue?vue&type=script&lang=js"
export * from "./DirectDealerManage.vue?vue&type=script&lang=js"
import style0 from "./DirectDealerManage.vue?vue&type=style&index=0&id=f7276ae4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7276ae4",
  null
  
)

export default component.exports